export default function calculateEndTime(startTime: string, duration: number) {
    const [startHour, startMinute] = startTime.split(":").map(Number);
    const totalMinutes = startHour * 60 + startMinute + duration;

    const endHour = Math.floor(totalMinutes / 60);
    const endMinute = totalMinutes % 60;

    return `${endHour}:${endMinute === 0 ? "00" : endMinute}`;
}
